import { Badge, HStack, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { useGetCreditsBalanceQuery } from '../redux/services/mixgenie';

/**
 * Header pill showing the user's credit balance. Skips the query entirely
 * when logged out (so anonymous visitors don't send an /subscriptions/current
 * that would 401). Clicking navigates to /credits where the user can top up
 * (once billing is enabled) or see their plan.
 */
export function CreditsBadge() {
  const { authenticated } = useAuth();
  const { data } = useGetCreditsBalanceQuery(undefined, { skip: !authenticated });
  if (!authenticated) return null;

  const remaining = data?.data?.creditsRemaining;
  return (
    <Badge
      as={Link}
      to="/credits"
      colorScheme="pink"
      variant="subtle"
      borderRadius="full"
      px={3}
      py={1}
      _hover={{ bg: 'pink.600', color: 'white' }}
      data-cta="nav:credits"
    >
      <HStack spacing={1}>
        <Text as="span" fontSize="sm" role="img" aria-label="credits">
          ⚡
        </Text>
        <Text as="span" fontSize="sm" fontWeight={700}>
          {typeof remaining === 'number' ? remaining : '—'}
        </Text>
      </HStack>
    </Badge>
  );
}
